import React, { Component, useEffect, useState } from "react";
import { Tabs, Divider, Button } from "antd";
import {
  AudioOutlined,
  VideoCameraOutlined,
  FileImageOutlined,
  FileAddOutlined,
} from "@ant-design/icons";
import InputsTab from "./Inputs";

import _ from "lodash";

import "./styles/main.scss";
import { useGlobalStore } from "../../../../stores/globalBackendStore";

const Index = (props) => {
  const {
    onSelect,
    item,
    inputs,
    handleRemovePlayer,
    onOrderChange,
    openEditSlideItem,
    feedType,
    onSlideItemChange,
  } = props;

  const apiSetup = useGlobalStore((state) => state.apiSetup);

  const [visibleEdit, setVisibleEdit] = useState(false);

  const [visibleInputEdit, setVisibleInputEdit] = useState(false);
  const [editData, setEditData] = useState({
    index: null,
    player: "",
    age: "",
    marketValue: "",
  });

  const [editInputData, setEditInputData] = useState({ index: null });

  const onSelectInput = (e, val) => {
    onSelect(e, val);
  };

  return (
    <React.Fragment>
      <InputsTab
        onSelect={onSelectInput}
        visibleEdit={visibleEdit}
        setVisibleEdit={setVisibleEdit}
        editData={editData}
        setEditData={setEditData}
        visibleInputEdit={visibleInputEdit}
        setVisibleInputEdit={setVisibleInputEdit}
        editInputData={editInputData}
        setEditInputData={setEditInputData}
        inputs={inputs}
        handleRemovePlayer={handleRemovePlayer}
        openEditSlideItem={openEditSlideItem}
        onOrderChange={onOrderChange}
        feedType={feedType}
        onSlideItemChange={onSlideItemChange}
      />
    </React.Fragment>
  );
};

export default Index;
